/* Poplar Bluff Trailer — product page: gallery + financing estimator
   Loaded by several product sections, so every initializer is idempotent. */
(function () {
  'use strict';

  function fmt(n) { return '$' + Math.round(n).toLocaleString(); }
  function payment(principal, months, aprPct) {
    var r = (aprPct / 100) / 12;
    if (r === 0) return principal / months;
    return principal * r / (1 - Math.pow(1 + r, -months));
  }

  /* ---------- Gallery ---------- */
  // Fullscreen lightbox shared by every gallery on the page (Greg: photos
  // must enlarge — shoppers read GVWR/VIN tags off them). Zoom: scroll wheel,
  // pinch, double-tap/double-click; drag to pan; swipe to change photo when
  // not zoomed. nav(dir) is wired per-gallery so arrows follow its images.
  var lb = null, lbImg = null, lbStage = null, lbNav = null;
  var Z = { s: 1, tx: 0, ty: 0 };
  var Z_MAX = 4;

  function lbApply() {
    // Clamp the pan so the image can't be dragged fully off screen.
    var mx = (Z.s - 1) * lbImg.clientWidth / 2;
    var my = (Z.s - 1) * lbImg.clientHeight / 2;
    Z.tx = Math.max(-mx, Math.min(mx, Z.tx));
    Z.ty = Math.max(-my, Math.min(my, Z.ty));
    lbImg.style.transform = 'translate(' + Z.tx + 'px,' + Z.ty + 'px) scale(' + Z.s + ')';
    lbStage.classList.toggle('zoomed', Z.s > 1.01);
  }
  function lbReset() { Z.s = 1; Z.tx = 0; Z.ty = 0; if (lbImg) lbApply(); }
  /* Zoom toward a stage point (px relative to stage center). */
  function lbZoomTo(scale, px, py) {
    var s2 = Math.max(1, Math.min(Z_MAX, scale));
    Z.tx = px - ((px - Z.tx) / Z.s) * s2;
    Z.ty = py - ((py - Z.ty) / Z.s) * s2;
    Z.s = s2;
    if (s2 === 1) { Z.tx = 0; Z.ty = 0; }
    lbApply();
  }
  function lbPoint(e) {
    var r = lbStage.getBoundingClientRect();
    return { x: e.clientX - r.left - r.width / 2, y: e.clientY - r.top - r.height / 2 };
  }

  function lbEnsure() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'gal-lightbox';
    lb.innerHTML =
      '<button class="lb-close" aria-label="Close">&#10005;</button>' +
      '<button class="lb-prev" aria-label="Previous image">&#8249;</button>' +
      '<div class="lb-stage"><img alt=""></div>' +
      '<button class="lb-next" aria-label="Next image">&#8250;</button>' +
      '<div class="lb-controls">' +
        '<div class="lb-zoombar">' +
          '<button class="lb-zout" aria-label="Zoom out">&#8722;</button>' +
          '<button class="lb-zreset" aria-label="Reset zoom">Reset</button>' +
          '<button class="lb-zin" aria-label="Zoom in">&#43;</button>' +
        '</div>' +
        '<div class="lb-legend">' +
          '<span class="lb-legend-desktop">Scroll to zoom &middot; Drag to pan &middot; Double-click zooms &middot; Esc closes</span>' +
          '<span class="lb-legend-touch">Pinch to zoom &middot; Drag to pan &middot; Double-tap zooms &middot; Swipe for next photo</span>' +
        '</div>' +
      '</div>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('img');
    lbStage = lb.querySelector('.lb-stage');
    // Deliberately NO backdrop/stage click-to-close: shoppers zooming around
    // tag photos kept falling out of the lightbox. Only the X and Escape close.
    lb.addEventListener('click', function (e) {
      if (e.target.classList.contains('lb-close')) lbClose();
    });
    lb.querySelector('.lb-prev').addEventListener('click', function () { if (lbNav) lbNav(-1); });
    lb.querySelector('.lb-next').addEventListener('click', function () { if (lbNav) lbNav(1); });
    lb.querySelector('.lb-zin').addEventListener('click', function () { lbZoomTo(Z.s * 1.5, 0, 0); });
    lb.querySelector('.lb-zout').addEventListener('click', function () { lbZoomTo(Z.s / 1.5, 0, 0); });
    lb.querySelector('.lb-zreset').addEventListener('click', function () { lbReset(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft' && lbNav) lbNav(-1);
      if (e.key === 'ArrowRight' && lbNav) lbNav(1);
    });

    /* Wheel zoom (desktop), toward the cursor. */
    lbStage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var p = lbPoint(e);
      lbZoomTo(Z.s * Math.exp(-e.deltaY * 0.0022), p.x, p.y);
    }, { passive: false });

    /* Double-click / double-tap: toggle 1x <-> 2.5x at the point. */
    lbStage.addEventListener('dblclick', function (e) {
      e.preventDefault();
      var p = lbPoint(e);
      lbZoomTo(Z.s > 1.01 ? 1 : 2.5, p.x, p.y);
    });

    /* Pointers: 1 = pan (zoomed) or swipe-nav (unzoomed); 2 = pinch. */
    var pts = new Map();
    var pinch0 = null; // { d, s, mid }
    var pan0 = null;   // { x, y, tx, ty, moved }
    var lastTap = { t: 0, x: 0, y: 0 };

    lbStage.addEventListener('pointerdown', function (e) {
      try { lbStage.setPointerCapture(e.pointerId); } catch (err) { /* capture is best-effort */ }
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 2) {
        var a = Array.from(pts.values());
        var r = lbStage.getBoundingClientRect();
        pinch0 = {
          d: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y),
          s: Z.s,
          mid: {
            x: (a[0].x + a[1].x) / 2 - r.left - r.width / 2,
            y: (a[0].y + a[1].y) / 2 - r.top - r.height / 2,
          },
        };
        pan0 = null;
      } else if (pts.size === 1) {
        pan0 = { x: e.clientX, y: e.clientY, tx: Z.tx, ty: Z.ty, moved: false };
      }
    });
    lbStage.addEventListener('pointermove', function (e) {
      if (!pts.has(e.pointerId)) return;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pinch0 && pts.size === 2) {
        var a = Array.from(pts.values());
        var d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
        if (pinch0.d > 0) lbZoomTo(pinch0.s * (d / pinch0.d), pinch0.mid.x, pinch0.mid.y);
      } else if (pan0 && pts.size === 1) {
        var dx = e.clientX - pan0.x, dy = e.clientY - pan0.y;
        if (Math.abs(dx) + Math.abs(dy) > 6) pan0.moved = true;
        if (Z.s > 1.01) {
          Z.tx = pan0.tx + dx;
          Z.ty = pan0.ty + dy;
          lbApply();
        }
      }
    });
    function pointerEnd(e) {
      if (!pts.has(e.pointerId)) return;
      pts.delete(e.pointerId);
      if (pts.size < 2) pinch0 = null;
      if (pan0 && pts.size === 0) {
        var dx = e.clientX - pan0.x, dy = e.clientY - pan0.y;
        if (Z.s <= 1.01 && Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5 && lbNav) {
          lbNav(dx < 0 ? 1 : -1); // swipe left = next photo
        } else if (!pan0.moved && e.pointerType === 'touch') {
          // Double-tap zoom (dblclick doesn't fire reliably on touch).
          var now = Date.now();
          if (now - lastTap.t < 320 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 30) {
            var p = lbPoint(e);
            lbZoomTo(Z.s > 1.01 ? 1 : 2.5, p.x, p.y);
            lastTap.t = 0;
          } else {
            lastTap = { t: now, x: e.clientX, y: e.clientY };
          }
        }
        pan0 = null;
      }
    }
    lbStage.addEventListener('pointerup', pointerEnd);
    lbStage.addEventListener('pointercancel', pointerEnd);
  }
  function lbShow(src, alt, nav) {
    lbEnsure();
    lbNav = nav || null;
    lb.classList.toggle('has-nav', Boolean(nav));
    lbImg.src = src.replace(/([?&])width=1200/, '$1width=2000');
    lbImg.alt = alt || '';
    lbReset();
    lb.classList.add('open');
    document.documentElement.classList.add('lb-locked');
  }
  function lbClose() {
    lbReset();
    lb.classList.remove('open');
    document.documentElement.classList.remove('lb-locked');
  }

  function initGallery(root) {
    if (root.dataset.galInit) return;
    var main = root.querySelector('[data-gal-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gal-thumb]'));
    if (main && !thumbs.length) {
      // Single-photo unit: still allow enlarging, just no arrows.
      root.dataset.galInit = '1';
      main.style.cursor = 'zoom-in';
      main.addEventListener('click', function () { lbShow(main.src, main.alt); });
      return;
    }
    if (!main || !thumbs.length) return;
    root.dataset.galInit = '1';
    var counter = root.querySelector('[data-gal-counter]');
    var total = thumbs.length;
    var idx = 0;

    function show(i) {
      idx = (i + total) % total;
      var t = thumbs[idx];
      var full = t.getAttribute('data-full') || (t.querySelector('img') && t.querySelector('img').src);
      if (full) main.src = full;
      var alt = t.getAttribute('data-alt');
      if (alt) main.alt = alt;
      thumbs.forEach(function (el, j) { el.classList.toggle('on', j === idx); });
      if (counter) counter.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    root.querySelectorAll('[data-gal-prev]').forEach(function (b) { b.addEventListener('click', function () { show(idx - 1); }); });
    root.querySelectorAll('[data-gal-next]').forEach(function (b) { b.addEventListener('click', function () { show(idx + 1); }); });
    show(0);

    main.style.cursor = 'zoom-in';
    main.addEventListener('click', function () {
      function nav(dir) { show(idx + dir); lbShow(main.src, main.alt, nav); }
      lbShow(main.src, main.alt, nav);
    });
  }

  /* ---------- Financing estimator ---------- */
  function initCalc(root) {
    if (root.dataset.calcInit) return;
    root.dataset.calcInit = '1';
    var price = parseFloat(root.getAttribute('data-price')) || 0;
    var apr = parseFloat(root.getAttribute('data-apr')) || 8.99;
    var downSlider = root.querySelector('[data-calc-down]');
    var termSlider = root.querySelector('[data-calc-term]');
    var amtEl = root.querySelector('[data-calc-amount]');
    var downEl = root.querySelector('[data-calc-down-value]');
    var termEl = root.querySelector('[data-calc-term-value]');
    var monthlyEl = root.querySelector('[data-calc-monthly]');

    function update() {
      var down = downSlider ? +downSlider.value : 0;
      var term = termSlider ? +termSlider.value : 60;
      var financed = Math.max(price - down, 0);
      if (amtEl) amtEl.textContent = fmt(financed);
      if (downEl) downEl.textContent = fmt(down);
      if (termEl) termEl.textContent = term + ' months';
      if (monthlyEl) monthlyEl.textContent = Math.round(payment(financed, term, apr)).toLocaleString();
    }
    if (downSlider) downSlider.addEventListener('input', update);
    if (termSlider) termSlider.addEventListener('input', update);
    update();
  }

  /* ---------- Static monthly estimate badges ---------- */
  function initEstimates() {
    document.querySelectorAll('[data-est-monthly]').forEach(function (el) {
      if (el.dataset.estInit) return;
      el.dataset.estInit = '1';
      var p = parseFloat(el.getAttribute('data-price')) || 0;
      var a = parseFloat(el.getAttribute('data-apr')) || 8.99;
      var t = parseFloat(el.getAttribute('data-term')) || 60;
      el.textContent = Math.round(payment(p, t, a)).toLocaleString();
    });
  }

  function run() {
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-calc]').forEach(initCalc);
    initEstimates();
  }

  /* Document-level listeners: register only once across multiple loads */
  if (!window.__pbtPdpBound) {
    window.__pbtPdpBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-share]');
      if (!btn) return;
      e.preventDefault();
      var data = { title: document.title, url: window.location.href };
      if (navigator.share) { navigator.share(data).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(window.location.href); btn.classList.add('copied'); }
    });
  }

  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
})();
